import { Helmet } from "react-helmet-async";

/**
 * SiteAnalytics — global SEO + (optional, self-hosted) analytics injector.
 *
 * Why no third-party tracker by default?
 *   • Cartonomie already ships a built-in admin analytics dashboard
 *     (/admin/analytics) backed by our own `site_visits` collection.
 *   • That keeps the stack 100% free, RGPD-friendly (no third-party transfer)
 *     and self-sovereign.
 *
 * Env vars (all optional, only injected when set):
 *   • REACT_APP_GSC_VERIFICATION — Google Search Console meta token.
 *   • REACT_APP_ANALYTICS_SRC    — full URL of a self-hosted analytics script
 *                                  (e.g. Umami: https://your.umami.host/script.js).
 *   • REACT_APP_ANALYTICS_ID     — site id passed to the script as data-website-id
 *                                  (Umami convention). Only used if SRC is set.
 *
 * If both env vars are empty, this component renders nothing — that's the
 * default state and is intentional.
 */
export default function SiteAnalytics() {
  const gscToken = process.env.REACT_APP_GSC_VERIFICATION;
  const analyticsSrc = process.env.REACT_APP_ANALYTICS_SRC;
  const analyticsId = process.env.REACT_APP_ANALYTICS_ID;

  return (
    <Helmet>
      {gscToken && <meta name="google-site-verification" content={gscToken} />}
      {analyticsSrc && analyticsId && (
        <script defer src={analyticsSrc} data-website-id={analyticsId} />
      )}
    </Helmet>
  );
}
